import { ThemeOverride } from './types';
import { overrideDefaultTheme } from './theme';

export const override: ThemeOverride = {
  name: 'brightworld',
  colors: {
    primary: {
      default: '#4C12A1',
      hover: '#4C12A1'
    },
    heading: {
      mark: '#E5006D',
      background: [
        '#CAE7E6',
        '#F9D2E5',
        '#CFC8F7',
        '#FFECB7'
      ]
    },
    textBlock: {
      border: '#9AAEBB',
      background: '#FAF5FF'
    },
    header: {
      background: '#4C12A1',
      nav: {
        arrow: '#4C12A1',
        searchBar: {
          border: '#9aaebb',
          text: '#56707a'
        },
        link: {
          text: '#4c12a1'
        },
        mobile: {
          titleMain: '#213038',
          background: '#faf5ff',
          typeLink: '#4c12a1'
        },
        desktop: {
          titleMain: '#213038',
          hover: {
            text: '#4c12a1',
            background: '#faf5ff'
          }
        },
        mark: {
          background: '#E5006D',
          color: '#fff'
        }
      }
    },
    link: {
      default: '#4C12A1',
      hover: '#FAF5FF'
    },
    message: {
      default: '#4C12A1',
      hover: '#FAF5FF'
    },
    table: {
      text: '#213038',
      border: '#E5006D',
      heading: '#F9D2E5',
      label: '#FDEDF5',
      labelText: '#333',
      cell: '#F2F3F4'
    },
    pageAnchor: {
      title: '#56707a',
      border: '#cdd8df'
    },
    textBlockHalfWidth: {
      border: '#CDD8DF',
      text: '#213038',
      icon: '#4C12A1',
      dropDownBackground: '#f2f3f4'
    },
    form: {
      placeholder: '#56707a',
      text: '#000',
      border: '#9AAEBB',
      valid: '#71BD6A',
      error: '#C90404'
    },
    selectionTitle: {
      title: '#000',
      description: '#333'
    },
    banner: {
      border: '#cdd8df',
      background: '#faf5ff',
      text: '#213038'
    },
    alertBar: {
      background: '#ffefef'
    }
  },
  fontWeights: {
    normal: 'normal',
    700: '700',
    bold: 'bold'
  },
  borderRadius: ['4px', '10px', '15px'],
  fonts: {
    default: {
      fontFamily: 'CurrysSans, sans-serif'
    }
  }
};

export default overrideDefaultTheme(override);
